<template>
  <div class="p-col-12">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div class="card p-shadow-app">
      <header class="jumbotron">
        <h3>
          Ficha do colaborador <strong>{{ userInfo.username }}</strong>
        </h3>
      </header>
      <TabView>
        <TabPanel header="Informação Geral">
          <Profile
            :userId="$route.params.id"
            v-on:userInfoLoaded="userHasLoaded"
          />
        </TabPanel>
        <TabPanel
          header="Lista de Verificação Entrada/Saída"
          v-if="can('updateEntranceExitChecklist')"
        >
          <UserEntranceExitChecklist
            v-if="userInfo.id != undefined"
            :userId="$route.params.id"
            :exitDate="userInfo.exitDate"
          />
        </TabPanel>
        <TabPanel
          header="Ficha de Integração"
          v-if="can('updateUserIntegration')"
        >
          <UserIntegration
            v-if="userInfo.id != undefined"
            :userId="$route.params.id"
          />
        </TabPanel>
      </TabView>
    </div>
  </div>
</template>

<script>
import UserEntranceExitChecklist from "@/components/profile/UserEntranceExitChecklist";
import UserIntegration from "@/components/profile/UserIntegration";
import Profile from "./Profile";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

export default {
  name: "ProfileView",
  components: {
    UserEntranceExitChecklist,
    UserIntegration,
    TabView,
    TabPanel,
    Profile,
  },
  data() {
    return {
      userInfo: { username: "" },
    };
  },
  computed: {
    currentUser() {
      if (this.$store.state.auth.loggedIn) {
        return this.$store.state.auth.user;
      }
      return null;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
  created() {},
  methods: {
    userHasLoaded(userInfo) {
      this.userInfo = userInfo;
    },
  },
};
</script>
